// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
 
const firebaseConfig = {
    apiKey: "AIzaSyBHpA1Uds_luHO9NVN-dWDvyIdF5dqoaUU",
    authDomain: "bindoo-collectives.firebaseapp.com",
    databaseURL: "https://bindoo-collectives-default-rtdb.firebaseio.com",
    projectId: "bindoo-collectives",
    storageBucket: "bindoo-collectives.appspot.com",
    messagingSenderId: "937810583466",
    appId: "1:937810583466:web:c5529466aa64a68289d5d3",
    measurementId: "G-VBRMTC048E"
};

// Initialize Firebase
const FBAPP = initializeApp(firebaseConfig);
// getAnalytics(FBAPP);

export const app = FBAPP;
export const db = getFirestore(FBAPP)
export const auth = getAuth(app)
// export const msg = getMessaging(app);
